/**
 * TitleBlock.jsx - the sheet's masthead: project, customer, overall status and
 * the generated/loaded timestamps.
 */
import { GREEN, GREY, GREY_LIGHT, INK, RULE, SUBLABEL } from './theme';
import { fmtStamp, relTime } from './helpers';
import { Wordmark } from './Primitives';

export function MetaRow({ label, children }) {
  return (
    <div className="svm-metaRow">
      <span
        style={{
          fontSize: 8.5,
          fontWeight: 800,
          letterSpacing: '1.5px',
          textTransform: 'uppercase',
          color: GREY_LIGHT,
          whiteSpace: 'nowrap',
          flexShrink: 0,
        }}
      >
        {label}
      </span>
      <span
        className="svm-metaVal"
        style={{
          fontSize: 11.5,
          fontWeight: 600,
          color: INK,
          lineHeight: 1.4,
          fontVariantNumeric: 'tabular-nums',
          minWidth: 0,
          maxWidth: 300,
          overflowWrap: 'anywhere',
        }}
      >
        {children}
      </span>
    </div>
  );
}

export function StatusValue({ status }) {
  const live = status === 'live';
  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 7,
        fontWeight: 800,
        letterSpacing: '1.3px',
        fontSize: 10.5,
        color: live ? GREEN : GREY,
      }}
    >
      <span
        style={{
          width: 8,
          height: 8,
          display: 'inline-block',
          borderRadius: 0,
          boxSizing: 'border-box',
          background: live ? GREEN : 'transparent',
          border: live ? 'none' : '1px solid ' + GREY_LIGHT,
        }}
      />
      {live ? 'LIVE' : 'INACTIVE'}
    </span>
  );
}

export function TitleBlock({ project, status, generatedAt, loadedAt, now }) {
  const generated = fmtStamp(generatedAt);
  const refreshed = relTime(loadedAt, now);
  return (
    <div>
      <div className="svm-title">
        <div style={{ minWidth: 0 }}>
          <Wordmark />
          <div className="svm-ident" style={{ ...SUBLABEL, marginTop: 16, maxWidth: 158, lineHeight: 1.7 }}>
            System verification and buy-off record
          </div>
        </div>
        <div style={{ minWidth: 0, maxWidth: '100%' }}>
          <div
            className="svm-metaVal"
            style={{
              fontSize: 10,
              fontWeight: 800,
              letterSpacing: '2.3px',
              textTransform: 'uppercase',
              color: GREEN,
              whiteSpace: 'nowrap',
              paddingBottom: 6,
              marginBottom: 6,
              borderBottom: '1px solid ' + RULE,
            }}
          >
            System Verification Report
          </div>
          {project ? <MetaRow label="Project">{project}</MetaRow> : null}
          {status ? (
            <MetaRow label="Status">
              <StatusValue status={status} />
            </MetaRow>
          ) : null}
          {generated ? <MetaRow label="Data as of">{generated}</MetaRow> : null}
          {refreshed ? <MetaRow label="Refreshed">{refreshed}</MetaRow> : null}
          {status ? <MetaRow label="Access">Read only</MetaRow> : null}
        </div>
      </div>
      <div style={{ height: 2, background: GREEN, marginTop: 16 }} />
    </div>
  );
}

/* -------------------------------- summary band ------------------------------- */
